import styled from 'styled-components';

export const SLeft = styled.div``;
export const SRight = styled.div``;
